module.exports = __webpack_public_path__ + "img/image-meditation.ab3e781c.png";